import { Box } from '@mui/material'
import { DateTimePicker, DateTimePickerProps } from '@mui/x-date-pickers'
import dayjs from 'dayjs'
import { Controller, FieldValues, FormState, UseControllerProps } from 'react-hook-form'

type FieldProps = Pick<DateTimePickerProps<boolean>, 'disabled'>

interface Props<T extends FieldValues> extends UseControllerProps<T>, FieldProps {
  formState: FormState<T>
  label: string
  onChange?: (value?: Date) => Promise<void> | void
  dataCy?: string
}

export const ControlledDateTimePicker = <T extends FieldValues>({
  name,
  control,
  label,
  disabled,
  formState: { errors },
  onChange,
  dataCy,
}: Props<T>) => {
  return (
    <Box data-cy={dataCy}>
      <Controller
        control={control}
        name={name}
        render={({ field }) => (
          <DateTimePicker
            label={label}
            value={dayjs(field.value)}
            slotProps={{
              textField: {
                helperText: errors[name]?.message as string,
                error: !!errors[name],
                fullWidth: true,
              },
            }}
            disabled={disabled}
            onChange={newValue => {
              if (onChange) {
                onChange(newValue?.toDate())
              }
              field.onChange(newValue)
            }}
          />
        )}
      />
    </Box>
  )
}
